import React from 'react';
import { MenuLink } from '@src/modules/Layout/shared/MenuLink';
import { STATS_ROUTES } from '../../constants';
import { Icon } from '@therms/atalaya';
import { MdAreaChart } from 'react-icons/md';

function StatsMenuLink() {
  return (
    <MenuLink to={STATS_ROUTES.__ROOT__}>
      <div className="inline-flex items-center gap-x-sm">
        <Icon Icon={MdAreaChart} />
        <span>Stats</span>
      </div>
    </MenuLink>);

}

export { StatsMenuLink };